<template>
    <ul class="main-menu">
        <li
            v-for="(item, index) in items"
            :key="index"
            class="item"
        >
            <button
                v-if="item.subMenu"
                class="link has-children"
                @click.prevent.stop="select(item.subMenu as SubMenuFragment)"
            >
                {{ item.title }}
            </button>

            <CmsLink
                v-else
                :link="item.link"
                class="link"
                @click="close()"
            >
                {{ item.title }}
            </CmsLink>
        </li>
    </ul>
</template>

<script setup lang="ts">
import type { HeaderMenuFragment, SubMenuFragment } from '@/graphql/api'

import CmsLink from '@/components/cms/CmsLink.vue'

defineProps<{
    items: HeaderMenuFragment[]
}>()

const emit = defineEmits<{
    select: [subMenu: SubMenuFragment]
    close: []
}>()

const select = (subMenu: SubMenuFragment) => {
    emit('select', subMenu)
}

const close = () => emit('close')
</script>

<style lang="scss" scoped>
.main-menu {
    .item {
        width: 100%;

        .link {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: $slate;
            padding: 15px 20px 15px 30px;
            font-family: $effra-font-stack;
            letter-spacing: 0.05em;
            font-weight: 400;
            text-transform: uppercase;
            font-size: 0.875rem;
            line-height: 1.25rem;

            &.has-children {
                &::after {
                    font-family: $icon-font;
                    content: $icon-angle-right;
                    font-size: 0.75rem;
                }
            }
        }
    }
}
</style>
